import { CurrencyRupee, History, PaymentOutlined, VisibilityRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import Select from "react-select";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { getCityWiseWalletList } from "src/api/commonapi";
import Page from "src/components/Page";
import WalletHistoryModal from "./walletHistoryModal";
import { useNavigate } from "react-router-dom";
import { fetchallcitylist } from "src/utils/common";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function Index() {
  const user = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [rowPerPage, setRowsPerPage] = useState(10);
  const [walletData, setWalletData] = useState([]);
  const [allCityList, setAllCityList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterData, setFilterData] = useState({
    type: -1,
    search: "",
    city_id: 0
  });

  const handleCityWiseWalletList = async (data) => {
    setIsLoading(true);
    const resp = await getCityWiseWalletList({
      page: page,
      per_page: rowPerPage,
      type: data?.type,
      search: data?.search,
      city_id: data?.city_id
    });
    setIsLoading(false);
    if (resp.status == 1) {
      setWalletData(resp?.data?.data);
      setTotalRows(resp?.data.counter);
    }
  };

  const getallcitylist = async () => {
    setAllCityList(await fetchallcitylist());
  };

  useEffect(async () => {
    if (filterData.city_id == 0) getallcitylist();
  }, []);

  const columns = [
    { name: "No", selector: (row, index) => index + 1 + (page - 1) * rowPerPage, width: "100px" },
    {
      name: "City Name",
      wrap: true,
      selector: (row) => row?.city_name
    },
    {
      name: "City Ambassador Name",
      wrap: true,
      selector: (row) => row?.name
    },
    {
      name: "Wallet Ballance",
      wrap: true,
      selector: (row) => row?.stock_wallet_balance
    },
    {
      name: "Pending Payout",
      wrap: true,
      selector: (row) => row?.stock_pending_balance
    },
    {
      name: "Pending Capture",
      wrap: true,
      selector: (row) => row?.stock_captured_pending_amount
    },
    {
      name: "Captured Balance",
      wrap: true,
      selector: (row) => row?.stock_captured_amount
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "150px",
      selector: (row) => (
        <>
          <Tooltip title="Wallet History">
            <IconButton
              onClick={() => {
                navigate("/citywallethistory", { state: row });
                // toggleWalletHistoryModel();
              }}
            >
              <VisibilityRounded color="primary" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  useEffect(() => {
    handleCityWiseWalletList(filterData);
  }, [page, rowPerPage]);

  const statusList = [
    { label: "All", value: -1 },
    { label: "Pending Payout", value: 0 },
    { label: "Pending Capture", value: 2 },
    { label: "Captured", value: 1 }
  ];

  return (
    <>
      <Page title="Product History">
        <Container maxWidth="md">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  City Stock Wallet
                </Typography>
              </Stack>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3}>
              <Stack>
                <label>Select Payment Status</label>
                <Select
                  options={statusList}
                  value={statusList.map((c) => {
                    if (c.value == filterData.type) {
                      return { value: c.value, label: c.label };
                    }
                  })}
                  onChange={(e) => {
                    setFilterData({
                      ...filterData,
                      type: e.value
                    });
                  }}
                />
              </Stack>
            </Grid>
            <Grid item xs={3}>
              <Stack spacing={3}>
                <label>Select City</label>
                <Select
                  value={
                    filterData.city_id == 0
                      ? {
                          value: 0,
                          label: "All City"
                        }
                      : allCityList.map((city) => {
                          return (
                            filterData.city_id == city.city_id && {
                              value: city.city_id,
                              label: city.city_name
                            }
                          );
                        })
                  }
                  onChange={(e) => {
                    setFilterData({
                      ...filterData,
                      city_id: e.value
                    });
                  }}
                  options={[
                    {
                      value: 0,
                      label: "All City"
                    },
                    ...allCityList.map((city) => {
                      return {
                        label: city?.city_name,
                        value: city?.city_id
                      };
                    })
                  ]}
                  menuPortalTarget={document.body}
                />
              </Stack>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} style={{ marginTop: "22px" }}>
              <TextField
                size="small"
                label="Search"
                name="search"
                autoComplete="off"
                // sx={{ width: 280 }}
                onChange={(e) => {
                  setFilterData({ ...filterData, search: e.target.value });
                }}
                value={filterData.search || ""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} style={{ marginTop: "22px" }}>
              <Button
                variant="contained"
                onClick={() => handleCityWiseWalletList(filterData)}
                style={{ marginRight: "10px" }}
              >
                Search
              </Button>
              <Button
                variant="contained"
                color="inherit"
                onClick={() => {
                  handleCityWiseWalletList({ search: "", type: -1, city_id: 0 });
                  setFilterData({ search: "", type: -1, city_id: 0 });
                }}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              pagination
              highlightOnHover
              paginationServer
              paginationTotalRows={totalRows}
              onChangePage={(p) => setPage(p)}
              onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
              columns={columns}
              data={walletData != null ? walletData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
